var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"evolution-chart"},[_c('BarChart',{staticClass:"evolution-chart",attrs:{"chart-options":_vm.options,"height":'200px',"handle-click":'selectDate',"series":_vm.chartData},on:{"selectDate":_vm.selectDate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }